import styled from 'styled-components';

import DateRangePicker, {
  Calendar,
  DayNameList,
  DayList,
  Content,
  Tabs,
  DayName,
  MODE_START,
  MODE_END,
} from './DateRangePicker';

export default styled(DateRangePicker)`
  ${Tabs} {
    display: none;
  }
  min-width: 355px;
  color: #01579b;
  ${DayNameList} {
    padding: 2px 0px 5px 0px;
  }
  ${DayList} {
    padding: 0;
  }
  ${DayName} {
    color: #01579b;
    font-weight: 500;
  }
  ${Content} {
    padding: 0px;
    margin: 0 20px;
    overflow-y: visible;
  }
  ${Calendar} {
    border: none;
    border-top: 2px solid;
    padding-top: 14px;
    background: none;
  }
  padding-top: 10px;
`;

export { MODE_START, MODE_END };
